import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics, isSupported } from 'firebase/analytics';

/**
 * Firebase configuration.
 * Mirrors Flutter's environment-switched FirebaseOptionsMain.current.
 * Values come from .env.{development|uat|production} files.
 */
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);

/**
 * Default (local) persistence — Flutter web never calls setPersistence
 * (GenericHelpers.setFirebaseAuthMfaSession, which would set SESSION, is unused).
 */
export const auth = getAuth(firebaseApp);

/**
 * Initialize Firebase Analytics if supported.
 * Mirrors Flutter's FirebaseAnalyticService.init().
 */
export async function initAnalytics() {
  const supported = await isSupported();
  if (supported) {
    return getAnalytics(firebaseApp);
  }
  return null;
}
